<div class="d-flex me-3">
  <base-avatar
    [size]="avatarSize.large"
    [image]="currentAssignment?.profile?.avatar || ''"
    [avatarClasses]="['cursor-auto']"
  ></base-avatar>
  <div class="d-flex flex-column justify-content-center mx-2">
    <h3>{{ currentAssignment?.profile?.firstName + ' ' + currentAssignment?.profile?.lastName }}</h3>
    <div class="d-flex flex-wrap">
      <p class="me-2 mb-0">{{ currentAssignment?.customerDepartment?.name }}</p>
      <base-rating
        [currentRate]="currentRate"
        [reviewCount]="reviewCount"
      ></base-rating>
    </div>
  </div>
</div>
